/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";
import { getFromLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";
import {
    apiToken,
    apiUrl_forIntegrations,
    apiUrl_forIntegrations as baseUrl,
} from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get quickbooks token
export let cancelTokenApi;
export async function getToken(token, parms) {
    if (token) {
        const tokenPomise = await axios.get(
            baseUrl +
                "get_access_token?code=" +
                parms.code +
                "&realm_id=" +
                parms.realm_id +
                "&state=" +
                parms.state,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelTokenApi = c;
                }),
            }
        );
        return tokenPomise;
    } else {
        console.log("Please add required parameters");
    }
}

//refresh token

// get quickbooks token
export let cancelURLApi;
export async function getURL(token) {
    if (token) {
        const tokenPomise = await axios.get(baseUrl + "get_auth_url", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelURLApi = c;
            }),
        });
        return tokenPomise;
    } else {
        console.log("Please add required parameters");
    }
}

//getSettings
export let cancelGetSettingApi;
export async function getSettings(qb_realm_id) {
    if (qb_realm_id) {
        const settings = await axios.get(
            apiUrl_forIntegrations + "get_qb_settings/" + qb_realm_id,
            {
                headers: {
                    Authorization: `Bearer ${""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetSettingApi = c;
                }),
            }
        );
        return settings;
    } else {
        console.log("Please add required parameters");
    }
}

//updateSettings
export let cancelEditSettingsApi;
export async function editSettings(token, settingsData) {
    if ((token, settingsData)) {
        // settingsData.productExport = settingsData.productExport ? "1" : "0"
        settingsData.customerExport = settingsData.customerExport ? "1" : "0";
        settingsData.exportSettings = {
            automatic: settingsData.exportSettings.automatic ? "1" : "0",
            notifications: settingsData.exportSettings.notifications
                ? "1"
                : "0",
        };
        settingsData.createSale = settingsData.createSale ? "1" : "0";
        settingsData.createDeposit = settingsData.createDeposit ? "1" : "0";
        settingsData.createItem = settingsData.createItem ? "1" : "0";
        settingsData.updateStock = settingsData.updateStock ? "1" : "0";

        const qb_realm_id = getFromLocalStorage("qb_realm_id");
        settingsData.realm_id = qb_realm_id;
        const settings = await axios.post(
            apiUrl_forIntegrations + "save_qb_settings",
            settingsData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditSettingsApi = c;
                }),
            }
        );
        return settings;
    } else {
        console.log("Please add required parameters");
    }
}

// {
//     productExport: "TITLE" || "SKU,
//     customerExport: 0 || 1,
//         exportSettings : {
//         automatic: 0 || 1,
//             notifications : 0 || 1
//     },
//     createSale: 0 || 1,
//         createDeposit: 0 || 1,
//             createItem: 0 || 1,
//                 updateStock: 0 || 1
// }

// get qb auth url
export let cancelQbAuthURLApi;
export async function getQbAUthURL(token) {
    if (token) {
        const qbAuthURL = await axios.get(baseUrl + "get_auth_url", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelQbAuthURLApi = c;
            }),
        });
        return qbAuthURL;
    } else {
        console.log("Please add required parameters");
    }
}

// create qb customer
export let cancelCreateQbCustomerApi;
export async function createQbCustomer(token, qbCustomerData) {
    if ((token, qbCustomerData)) {
        const qbCustomers = await axios.post(
            baseUrl + "create_qb_customer",
            qbCustomerData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCreateQbCustomerApi = c;
                }),
            }
        );
        return qbCustomers;
    } else {
        console.log("Please add required parameters");
    }
}

// create qb item
export let cancelCreateQbItemApi;
export async function createQbItem(token, qbItemData) {
    if ((token, qbItemData)) {
        const qbItems = await axios.post(
            baseUrl + "create_qb_item",
            qbItemData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCreateQbCustomerApi = c;
                }),
            }
        );
        return qbItems;
    } else {
        console.log("Please add required parameters");
    }
}

//update qb item
export let cancelUpdateQbItemApi;
export async function updateQbItem(token, qbItemData, item_id) {
    if ((token, qbItemData, item_id)) {
        const qbItems = await axios.put(
            baseUrl + "update_qb_item?" + qbItemData.item_id,
            qbItemData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateQbItemApi = c;
                }),
            }
        );
        return qbItems;
    } else {
        console.log("Please add required parameters");
    }
}

//get item
export let cancelGetItemApi;
export async function getItem(token, item_id) {
    if (token && item_id) {
        const items = await axios.get(baseUrl + "get_item?" + item_id, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetItemApi = c;
            }),
        });
        return items;
    } else {
        console.log("Please add required parameters");
    }
}

//get customer
export let cancelGetCustomerApi;
export async function getCustomer(token, customer_id) {
    if (token && customer_id) {
        const customers = await axios.get(
            baseUrl + "get_customer?" + customer_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCustomerApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}

// get stores
export let cancelGetStoresApi;
export async function getStores(token) {
    if (token) {
        const stores = await axios.get(baseUrl + "/get_stores", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetStoresApi = c;
            }),
        });
        return stores;
    } else {
        console.log("Please add required parameters");
    }
}

// get store detail
export let cancelGetStoreDetailsApi;
export async function getStoreDetails(token, store_id) {
    if (token && store_id) {
        const store = await axios.get(baseUrl + "get_store?" + store_id, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetStoreDetailsApi = c;
            }),
        });
        return store;
    } else {
        console.log("Please add required parameters");
    }
}

// add store
export let cancelAddStoreApi;
export async function addStore(token, storeData) {
    if ((token, storeData)) {
        const store = await axios.post(
            baseUrl + "add_store",
            storeData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddStoreApi = c;
                }),
            }
        );
        return store;
    } else {
        console.log("Please add required parameters");
    }
}

// update store
export let cancelEditStoreApi;
export async function editStore(token, storeData) {
    if ((token, storeData)) {
        const store = await axios.put(
            baseUrl + "/" + storeData.store_id,
            storeData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditStoreApi = c;
                }),
            }
        );
        return store;
    } else {
        console.log("Please add required parameters");
    }
}

// delete store
export let cancelDeleteStoreApi;
export async function deleteStore(token, storeData) {
    if (token && storeData) {
        const store = await axios.delete(
            baseUrl + "delete_store?" + storeData.store_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteStoreApi = c;
                }),
            }
        );
        return store;
    } else {
        console.log("Please add required parameters");
    }
}
